import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Search, Heart, Plus } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Logo } from './Logo';
import { LocaleControls } from './header/LocaleControls';
import { MobileMenu } from './header/MobileMenu';
import { UserMenu } from './header/UserMenu';
import { useApp } from '../context/AppContext';

const Header = () => {
  const { t } = useApp();
  const [q, setQ] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const onSearch = (e) => {
    e.preventDefault();
    navigate(`/marketplace${q ? `?q=${encodeURIComponent(q)}` : ''}`);
  };

  const navLinks = [
    { id: 'browse', to: '/marketplace', label: t('nav.browse') },
    { id: 'diaspora', to: '/diaspora', label: t('nav.diaspora') },
    { id: 'pricing', to: '/pricing', label: t('nav.pricing') },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#EFEAE0]" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4 h-16">
          <Logo />
          <form onSubmit={onSearch} className="hidden md:flex flex-1 max-w-xl relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7A7468]" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('hero.search')} data-testid="header-search-input" className="pl-10 pr-4 h-10 bg-[#FAF7F2] border-[#EFEAE0] focus-visible:ring-[#0F8B5C] focus-visible:ring-offset-0" />
          </form>
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`nav-${l.id}`} className={({ isActive }) => `px-3 py-2 text-sm font-medium rounded-lg transition-colors ${isActive ? 'text-[#0F8B5C] bg-[#0F8B5C]/8' : 'text-[#3F3A30] hover:text-[#0F8B5C] hover:bg-[#FAF7F2]'}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden md:flex items-center gap-2 ml-auto">
            <LocaleControls />
            <Link to="/dashboard?tab=favorites" className="p-2 rounded-lg hover:bg-[#FAF7F2] transition-colors" data-testid="nav-favorites" aria-label={t('nav.favorites')}><Heart className="w-4 h-4 text-[#3F3A30]" /></Link>
            <UserMenu />
            <Link to="/post"><Button size="sm" className="bg-[#0F8B5C] hover:bg-[#0A6E47] text-white shadow-sm" data-testid="nav-post"><Plus className="w-4 h-4 mr-1.5" /> {t('nav.post')}</Button></Link>
          </div>
          <MobileMenu open={mobileOpen} onOpenChange={setMobileOpen} navLinks={navLinks} q={q} setQ={setQ} onSearch={onSearch} />
        </div>
      </div>
    </header>
  );
};

export default Header;
